import axios from "@/libs/api.request";

export const getCommissionList = filterCond => {
  return axios.request({
    url: "commission/getCommissionList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
